/**
 * Pure helper for default Voice Traffic settings per region.
 * Extracted from CalculatorContext so it can be unit-tested.
 *
 * Behaviour:
 *  - 'ua'    → UA package mode, 500 minutes
 *  - 'asia'  → KZ package mode, 500 minutes
 *  - 'eu' | 'other' (and any other unknown region) → custom amount mode, 0
 */
export const getDefaultVoiceTrafficSettings = (region) => {
  switch (region) {
    case 'ua':
      return {
        voiceTrafficCountriesMinutes: { UA: 500 },
        voiceTrafficUseCustomAmount: false,
        voiceTrafficCustomAmount: 0,
      };
    case 'asia':
      return {
        voiceTrafficCountriesMinutes: { KZ: 500 },
        voiceTrafficUseCustomAmount: false,
        voiceTrafficCustomAmount: 0,
      };
    default:
      return {
        voiceTrafficCountriesMinutes: {},
        voiceTrafficUseCustomAmount: true,
        voiceTrafficCustomAmount: 0,
      };
  }
};
